import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { ICruisePrefetch } from '../../../shared/interfaces/icruise-prefetch';
import { ModalStatusService } from '../../../shared/services/modal-status.service';

@Component({
  selector: 'app-engine-cruise-modal-itineraries',
  templateUrl: './engine-cruise-modal-itineraries.component.html',
  styleUrls: ['./engine-cruise-modal-itineraries.component.scss'],
})
export class EngineCruiseModalItinerariesComponent
  implements OnInit, OnChanges
{
  @Output() selectedItinerary: EventEmitter<number> =
    new EventEmitter<number>();
  @Input() defaultItinerary: number | string;
  @Input() cruisePrefetch$: Observable<ICruisePrefetch>;
  selectedItineraryInner: any;

  constructor(
    private _modalService: NgbModal,
    private _modalStatusService: ModalStatusService
  ) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.defaultItinerary && this.defaultItinerary) {
      this.defaultItinerary = Number(this.defaultItinerary);
      this.selectedItineraryInner = JSON.parse(
        JSON.stringify(this.defaultItinerary)
      );
      this.selectedItinerary.emit(this.selectedItineraryInner);
    }
  }

  open(content: any): void {
    if (!this._modalService.hasOpenModals()) {
      this._modalStatusService.hasOpenModals.next(true);
      this._modalService
        .open(content, {
          ariaLabelledBy: 'modal-engine',
          size: 'xl',
          modalDialogClass: 'modal-fullscreen-sm-down',
        })
        .result.finally(() =>
          this._modalStatusService.hasOpenModals.next(false)
        );
    }
  }

  deselectItineraryCB(): void {
    this.selectItinerary(undefined);
  }

  selectItinerary(itinerary: number, loadNextModal: boolean = false): void {
    this.selectedItineraryInner = itinerary;
    this.selectedItinerary.emit(itinerary);
    this._modalService.dismissAll();
  }
}
